@use "../../scss/colors";
@use "../../scss/breakpoints";

.gettingStartedWrapper {
	background-color: colors.$marketing_gray;
	padding: 48px 48px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	@include breakpoints.sm-down {
		padding: 48px 32px;
	}

	.gettingStarted {
		max-width: 1248px;
		margin: 0 auto;
		display: flex;
		gap: 64px;
		flex-direction: row;

		@include breakpoints.md-down {
			flex-direction: column;
			gap: 32px;
		}

		h2 {
			color: #333f48;
			font-size: 26px;
			line-height: 32px;
			font-weight: 350;
			flex-shrink: 1;

			@include breakpoints.sm-down {
				font-size: 24px;
			}
		}

		ul {
			list-style-type: none;
			margin: 0;
			padding: 0;
			min-width: 400px;
			flex-shrink: 0;
		}

		.linkRow {
			align-items: center;
			background-color: colors.$white;
			border: 1px solid colors.$nordic_light_grey;
			display: flex;
			justify-content: space-between;
			gap: 24px;
			margin-bottom: 16px;
			padding: 24px;
			text-decoration: none;
			max-width: 482px;
			font-size: 16px;
			font-style: normal;
			font-weight: 350;
			line-height: 21px;

			&:hover span,
			&:focus-visible span {
				text-decoration: underline;
			}
			&:focus-visible span {
				outline: 2px solid currentColor;
				outline-offset: 2px;
			}

			i {
				color: colors.$nordic_lake;
				display: inline-block;
			}
		}
	}
}
